import React from 'react';
import './WordStats.css';
import FingeringIndicator from './FingeringIndicator';
import FingeringText from './FingeringText';
import './FingeringIndicator.css';
const WordStats = props => (React.createElement("div", null,
    React.createElement("div", null,
        "This word is ",
        common(props.frequency),
        " in this language."),
    React.createElement(FingeringText, { fingeringObject: props.fingeringObject, text: props.word, standAlone: true }),
    React.createElement(FingeringIndicator, { fingeringObject: props.fingeringObject, text: props.word, showWord: false })));
const common = function (freq) {
    switch (freq) {
        case 0:
            return React.createElement("span", { className: 'freq c0' }, "extremely common");
        case 1:
            return React.createElement("span", { className: 'freq c1' }, "very common");
        case 2:
            return React.createElement("span", { className: 'freq c2' }, "common");
        case 3:
            return React.createElement("span", { className: 'freq c3' }, "somewhat common");
        case 4:
            return React.createElement("span", { className: 'freq c4' }, "somewhat uncommon");
        case 5:
            return React.createElement("span", { className: 'freq c5' }, "uncommon");
        case 6:
            return React.createElement("span", { className: 'freq c6' }, "very uncommon");
        case 7:
            return React.createElement("span", { className: 'freq c7' }, "extremely uncommon");
        default:
            return 'unknown';
    }
};
export default WordStats;
//# sourceMappingURL=WordStats.js.map